import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComplaintB2cComponent } from './complaint-b2c/complaint-b2c.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
    IconRegistryService,
    UiModule,
    iccIconAdd,
    iccIconAddPhoto,
    iccIconCommentQuote,
    iccIconConfigure,
    iccIconConstruction,
    iccIconControl,
    iccIconClose,
    iccIconDatePicker,
    iccIconDelete,
    iccIconDisabled,
    iccIconDone,
    iccIconEdit,
    iccIconEmail,
    iccIconInfo,
    iccIconInstall,
    iccIconLinkOff,
    iccIconList,
    iccIconLocation,
    iccIconNavigateNext,
    iccIconPerson,
    iccIconPhone,
    iccIconSearch,
    iccIconShoppingCart,
    iccIconTime,
    iccIconTimer,
    iccIconViewMap,
    iccIconVisible,
    iccIconWarning,
} from '@icc/ui';
import { ComplaintPositionEditComponent } from './complaint-position-edit/complaint-position-edit.component';
import { ComplaintPositionConfigurationSelectComponent } from './complaint-position-configuration-select/complaint-position-configuration-select.component';
import { ComplaintInfoComponent } from './complaint-info/complaint-info.component';
import { MaterialModule } from 'libs/configurator/ui/src/lib/material/material.module';
import { ComplaintsListComponent } from './complaints-list/complaints-list.component';
import { ComplaintFiltersComponent } from './complaint-filters/complaint-filters.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { B2BSharedModule } from 'libs/b2b/shared/src/lib/shared.module';
import { PhoneNumberValidatorDirective } from './phone-number-validator.directive';
import { ComplaintComponent } from './complaint/complaint.component';
import { ComplaintSummaryComponent } from './complaint-summary/complaint-summary.component';
import { ComplaintPositionComponent } from './complaint-position/complaint-position.component';
import { ComplaintUserPreviewDialogComponent } from './complaint-user-preview-dialog/complaint-user-preview-dialog.component';
import { ComplaintChangeUserDialogComponent } from './complaint-change-user-dialog/complaint-change-user-dialog.component';
import { ComplaintPositionDialogComponent } from './complaint-position-dialog/complaint-position-dialog.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { ComplaintDocumentPreviewComponent } from './complaint-document-preview/complaint-document-preview.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComplaintMapComponent } from './complaint-map/complaint-map.component';
import { ComplaintListTableComponent } from './complaint-list-table/complaint-list-table.component';
import { ComplaintAppointmentComponent } from './complaint-appointment/complaint-appointment.component';
import { ComplaintAppointmentDialogComponent } from './complaint-appointment-dialog/complaint-appointment-dialog.component';
import { ComplaintAppointmentEditComponent } from './complaint-appointment-edit/complaint-appointment-edit.component';
import { ComplaintAppointmentListComponent } from './complaint-appointment-list/complaint-appointment-list.component';
import { ComplaintAppointmentFiltersComponent } from './complaint-appointment-filters/complaint-appointment-filters.component';
import { ComplaintAppointmentListTableComponent } from './complaint-appointment-list-table/complaint-appointment-list-table.component';
import { AppointmentStatusComponent } from './appointment-status/appointment-status.component';
import { ComplaintStatusComponent } from './complaint-status/complaint-status.component';
import { ComplaintAppointmentProtocolDialogComponent } from './complaint-appointment-protocol-dialog/complaint-appointment-protocol-dialog.component';
import { ComplaintAppointmentProtocolEditComponent } from './complaint-appointment-protocol-edit/complaint-appointment-protocol-edit.component';
import { ComplaintAppointmentDeleteDialogComponent } from './complaint-appointment-delete-dialog/complaint-appointment-delete-dialog.component';
import { ComplaintSparePartsDialogComponent } from './complaint-spare-parts-dialog/complaint-spare-parts-dialog.component';
import { SharedUnitPipeModule } from '@icc/configurator/shared';
import { ComplaintNoteDialogComponent } from './complaint-note-dialog/complaint-note-dialog.component';
import { ComplaintNoteVisibilityComponent } from './complaint-note-visibility/complaint-note-visibility.component';
import { ComplaintAppointmentMapComponent } from './complaint-appointment-map/complaint-appointment-map.component';
import { ComplaintAppointmentPreviewComponent } from './complaint-appointment-preview/complaint-appointment-preview.component';
import { ComplaintAppointmentProtocolEmailSendComponent } from './complaint-appointment-protocol-email-send/complaint-appointment-protocol-email-send.component';
import { ComplaintEditDialogComponent } from './complaint-edit-dialog/complaint-edit-dialog.component';
import { ComplaintCorrectionDialogComponent } from './complaint-correction-dialog/complaint-correction-dialog.component';
import { ComplaintAppointmentNoteComponent } from './complaint-appointment-note/complaint-appointment-note.component';
import { ComplaintSurveyComponent } from './complaint-survey/complaint-survey.component';
import { ComplaintAppointmentProtocolListDialogComponent } from './complaint-appointment-protocol-list-dialog/complaint-appointment-protocol-list-dialog.component';
import { ComplaintMapDialogComponent } from './complaint-map-dialog/complaint-map-dialog.component';
import { ComplaintPartialMatchConfirmDialogComponent } from './complaint-partial-match-confirm-dialog/complaint-partial-match-confirm-dialog.component';
import { ComplaintComplainantDataDialogComponent } from './complaint-complainant-data-dialog/complaint-complainant-data-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule,
        UiModule,
        MaterialModule,
        NgxPaginationModule,
        B2BSharedModule,
        GoogleMapsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NgSelectModule,
        SharedUnitPipeModule,
    ],
    declarations: [
        ComplaintB2cComponent,
        ComplaintPositionEditComponent,
        ComplaintPositionConfigurationSelectComponent,
        ComplaintInfoComponent,
        ComplaintsListComponent,
        ComplaintFiltersComponent,
        PhoneNumberValidatorDirective,
        ComplaintComponent,
        ComplaintSummaryComponent,
        ComplaintPositionComponent,
        ComplaintUserPreviewDialogComponent,
        ComplaintChangeUserDialogComponent,
        ComplaintPositionDialogComponent,
        ComplaintDocumentPreviewComponent,
        ComplaintMapComponent,
        ComplaintListTableComponent,
        ComplaintAppointmentComponent,
        ComplaintAppointmentDialogComponent,
        ComplaintAppointmentEditComponent,
        ComplaintAppointmentListComponent,
        ComplaintAppointmentFiltersComponent,
        ComplaintAppointmentListTableComponent,
        AppointmentStatusComponent,
        ComplaintStatusComponent,
        ComplaintAppointmentProtocolDialogComponent,
        ComplaintAppointmentProtocolEditComponent,
        ComplaintAppointmentDeleteDialogComponent,
        ComplaintSparePartsDialogComponent,
        ComplaintNoteDialogComponent,
        ComplaintNoteVisibilityComponent,
        ComplaintAppointmentMapComponent,
        ComplaintAppointmentPreviewComponent,
        ComplaintAppointmentProtocolEmailSendComponent,
        ComplaintEditDialogComponent,
        ComplaintCorrectionDialogComponent,
        ComplaintAppointmentNoteComponent,
        ComplaintSurveyComponent,
        ComplaintAppointmentProtocolListDialogComponent,
        ComplaintMapDialogComponent,
        ComplaintPartialMatchConfirmDialogComponent,
        ComplaintComplainantDataDialogComponent,
    ],
})
export class ComplaintModule {
    constructor(private iconRegistry: IconRegistryService) {
        this.iconRegistry.registerIcons([
            iccIconPerson,
            iccIconLocation,
            iccIconEmail,
            iccIconPhone,
            iccIconDatePicker,
            iccIconSearch,
            iccIconConstruction,
            iccIconVisible,
            iccIconEdit,
            iccIconInfo,
            iccIconAddPhoto,
            iccIconAdd,
            iccIconInfo,
            iccIconList,
            iccIconViewMap,
            iccIconNavigateNext,
            iccIconConfigure,
            iccIconControl,
            iccIconClose,
            iccIconDelete,
            iccIconDisabled,
            iccIconDone,
            iccIconInstall,
            iccIconTime,
            iccIconTimer,
            iccIconShoppingCart,
            iccIconCommentQuote,
            iccIconLinkOff,
            iccIconWarning,
        ]);
    }
}
